import { QuestionOptionsServiceInterface } from 'domain/services';
import {
  ReorderQuestionOptionsUseCaseInterface,
  CreateQuestionOptionUseCaseInterface,
  DeleteQuestionOptionUseCaseInterface,
  GetQuestionOptionByIdUseCaseInterface,
  UpdateQuestionOptionUseCaseInterface,
} from 'domain/usecases';

interface UseCasesInjection {
  reorderQuestionOptions: ReorderQuestionOptionsUseCaseInterface;
  createQuestionOption: CreateQuestionOptionUseCaseInterface;
  updateQuestionOption: UpdateQuestionOptionUseCaseInterface;
  deleteQuestionOption: DeleteQuestionOptionUseCaseInterface;
  getQuestionOptionById: GetQuestionOptionByIdUseCaseInterface;
}

export class QuestionOptionsService implements QuestionOptionsServiceInterface {
  private readonly _reorderQuestionOptions: ReorderQuestionOptionsUseCaseInterface;
  private readonly _createQuestionOption: CreateQuestionOptionUseCaseInterface;
  private readonly _updateQuestionOption: UpdateQuestionOptionUseCaseInterface;
  private readonly _deleteQuestionOption: DeleteQuestionOptionUseCaseInterface;
  private readonly _getQuestionOptionById: GetQuestionOptionByIdUseCaseInterface;

  constructor(usecases: UseCasesInjection) {
    this._reorderQuestionOptions = usecases.reorderQuestionOptions;
    this._createQuestionOption = usecases.createQuestionOption;
    this._updateQuestionOption = usecases.updateQuestionOption;
    this._deleteQuestionOption = usecases.deleteQuestionOption;
    this._getQuestionOptionById = usecases.getQuestionOptionById;
  }

  reorderQuestionOptions(
    params: ReorderQuestionOptionsUseCaseInterface.Params,
  ): Promise<ReorderQuestionOptionsUseCaseInterface.Result> {
    return this._reorderQuestionOptions.execute(params);
  }

  updateQuestionOption(
    params: UpdateQuestionOptionUseCaseInterface.Params,
  ): Promise<UpdateQuestionOptionUseCaseInterface.Result> {
    return this._updateQuestionOption.execute(params);
  }

  createQuestionOption(
    params: CreateQuestionOptionUseCaseInterface.Params,
  ): Promise<CreateQuestionOptionUseCaseInterface.Result> {
    return this._createQuestionOption.execute(params);
  }

  getQuestionOptionById(
    params: GetQuestionOptionByIdUseCaseInterface.Params,
  ): Promise<GetQuestionOptionByIdUseCaseInterface.Result> {
    return this._getQuestionOptionById.execute(params);
  }

  deleteQuestionOption(
    params: DeleteQuestionOptionUseCaseInterface.Params,
  ): Promise<DeleteQuestionOptionUseCaseInterface.Result> {
    return this._deleteQuestionOption.execute(params);
  }
}
